import React, { useState } from 'react';

const GenbiLandingComponent = () => {
  const [activeTab, setActiveTab] = useState(0);

  // Data structure for HEOR tabs and their cards
  const tabsData = [
    {
      label: "Dossiers",
      cards: [
        {
          icon: "bi bi-globe",
          title: "Global Value Dossier",
          content: "Generates dossier in multiple formats to support global market access strategy and enable local affiliate success.",
          tags: ["Unmet Need", "Market Dynamics", "Value Proposition"]
        },
        {
          icon: "bi bi-globe-europe-africa",
          title: "HTA Dossier",
          content: "Create submission-ready HTA dossiers for NICE, CADTH, and G-BA requirements, to achieve reimbursement approval.",
          tags: ["NICE", "IQWiG/G-BA", "HAS", "CADTH", "PBAC"]
        },
        {
          icon: "bi bi-globe-americas",
          title: "AMCP Dossier",
          content: "Dossiers following AMCP format to secure formulary placement for US managed care organizations.",
          tags: ["US Market", "Managed Care", "Payer Budget Impact"]
        }
      ]
    },
    {
      label: "Modelling",
      cards: [
        {
          icon: "bi bi-coin",
          title: "Cost-Effectiveness Model Analytics",
          content: "Analyze cost-effectiveness models and generate ICER reports automatically",
          tags: ["Cost-Effectiveness", "ICER", "QALY", "Economic Analysis", "HTA"]
        },
        {
          icon: "bi bi-piggy-bank",
          title: "Budget Impact Model Analytics",
          content: "Create budget impact analyses for healthcare payers and health systems",
          tags: ["Budget Impact", "Financial", "Payers", "Healthcare Systems", "Affordability"]
        },
        {
          icon: "bi bi-shuffle",
          title: "Markov Model Analytics",
          content: "State occupancy analytics, probabilistic sensitivity analytics etc.",
          tags: ["Trace analysis", "Long-term outcome projections"]
        }
      ]
    },
    {
      label: "Evidence Synthesis",
      cards: [
        {
          icon: "bi bi-ui-checks",
          title: "SLR Evidence Synthesis",
          content: "Structured synthesis of key findings, quality assessment, and recommendations based on the literature reviewed.",
          tags: [  "Evidence  Certainty","Sensitivity Analysis", "Statistical Synthesis"]
        },
        {
          icon: "bi bi-ui-checks-grid",
          title: "TLR Evidence Synthesis",
          content: " Focused synthesis of key findings, targeted quality assessment, and recommendations based on the scoped literature reviewed.",
          tags: ["Strategic Recommendations", " Focused Insights"]
        },
        {
          icon: "bi bi-capsule",
          title: "Biomarker Evidence Analytics",
          content: "Integrate genomic data, laboratory results, and biomarker studies to synthesize evidence on biomarkers.",
          tags: ["Genomic Data", "Precision Medicine", "Laboratory Outcomes"]
        }
      ]
    },
    {
      label: "Market Intelligence",
      cards: [
        {
          icon: "bi bi-map",
          title: "Landscape Assessment",
          content: "Analyze disease burden, treatment pathways, and competitive landscapes comprehensively",
          tags: ["Treatment Landscape", "Market Research", "TPP"]
        },
        {
          icon: "bi bi-person-video3",
          title: "Payer Landscape Analysis",
          content: "Map payer environments, reimbursement criteria, and market access requirements",
          tags: ["Payers", "Reimbursement", "Market Access", "Coverage"]
        },
        {
          icon: "bi bi-graph-up",
          title: "Market Sizing Analysis",
          content: "Forecast patient populations, addressable markets, and revenue projections accurately",
          tags: ["Market Sizing", "Forecasting", "Patient Population"]
        }
      ]
    }
  ];

  return (
    <div className="ev-card-2 d-flex justify-content-center align-items-center w-100 ev-padding-xlarge2 dashboard-landing-container">
      <div className="container-fluid">
        <p className="ev-med-p-blue mb-1 text-center fs-20 ev-bold-reg" >Gen BI Studio</p>
        <p className="ev-small-p-dark mb-5 text-center w-50 m-auto" >Accelerate your healthcare decisions using Generative AI driven business intelligence</p>
        
        {/* Tab Buttons */}
        <div className="row">
          <div className="col-12 text-center">
            {tabsData.map((tab, index) => (
              <button
                key={index}
                className={`ev-bold-reg mx-1 px-4 ${activeTab === index ? 'ev-btn-blue-fill-round' : 'ev-btn-blue-outline-round'}`}
                onClick={() => setActiveTab(index)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Cards Container */}
        <div className="row">
          {tabsData[activeTab].cards.map((card, cardIndex) => (
            <div key={cardIndex} className="col-lg-4 col-md-6 col-12 margin-bottom-3 ev-padding-small">
              <div className="genbi-landing-page-e-card genbi-landing-page-playing h-100">
                <div className="genbi-landing-page-card-icon">
                  <i className={`${card.icon}`}></i>
                </div>
                
                <div className="genbi-landing-page-wave"></div>
                <div className="genbi-landing-page-wave"></div>
                <div className="genbi-landing-page-wave"></div>
        
                <div className="genbi-landing-page-infotop">
                  <h5 className="mb-2 ev-message-card4 ev-reg-p-dark">{card.title}</h5>
                  <div className="ev-small-p-blue mb-4 ms-2">
                    {card.content}
                  </div>
                  
                  {/* Tags Section */}
                  <div className="d-flex flex-wrap">
                    {card.tags.map((tag, tagIndex) => (
                      <span 
                        key={tagIndex} 
                        className="ev-message-card2 ev-xsmall-p-blue m-1 ev-radius-large ev-btn-small"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div> 
            </div>
          ))}
        </div>

        <p className="ev-med-p-blue mt-4 mb-1">Get Started.</p>
        <p className="ev-small-p-dark mb-0 ev-reg" >1. click on <span className="ev-alert-card-warning ev-btn-xsmall">Create Template</span> to build intelligent workflows.</p>
        <p className="ev-small-p-dark mb-0 ev-reg">2. Browse your saved templates and continue your work via the side panel.</p>
      </div>
    </div>
  );
};

export default GenbiLandingComponent;